import { axosInstance, refreshUseCaseImpl } from './axios_instance_di';
//Controllers
import LoginController from '@/module/login/controller/login_controller';
import DefaultController from "@/module/default/controller/default_controller";
import HomeController from '@/module/home/controller/home_controller';
import DashboardController from '@/module/dashboard/controller/dashboard_controller';
import ModelController from '@/module/model/controller/model_controller';
import CodeController from '@/module/code/controller/code_controller';
import ClientController from '@/module/client/controller/client_controller'
import VehicleController from '@/module/vehicle/controller/vehicle_controller';
import EquipmentController from '@/module/equipment/controller/equipment_controller';
import AccountController from '@/module/account/controller/account_controller';
import ReleaseController from '@/module/release/controller/release_controller';
import DashboardServiceOrderControllerPanel from '@/module/dashboardServiceOrderPanel/controller/dashboard_service_order_panel_controller';
import ServiceOrderController from '@/module/serviceOrder/controller/service_order_controller';
import VisitServiceOrderController from '@/module/visitServiceOrder/controller/visit_service_order_controller';
import TechnicianController from '@/module/technician/controller/technician_controller';
import EquipmentHistoryController from '@/module/equipmentHistory/controller/equipmentHistory_controller';
import VehicleMaintenanceController from '@/module/vehicleMaintenance/controller/vehicleMaintenance_controller';
import TruckDriverController from '@/module/truckDriver/controller/truckDriver_controller';
import ReleaseConfirmationController from '@/module/releaseConfirmation/controller/releaseConfirmation_controller';
import EquipmentStatusController from '@/module/equipmentStatus/controller/equipmentStatus_controller';

//Login
import loginRepostory from "@/core/data/repository/login_repository";
import loginUseCase from "@/core/domain/usecase/login_usecase";

const fetchAccountGroupPermissionsRepositoryImpl = fetchAccountGroupPermissionsRepository(axosInstance)
const fetchAccountGroupPermissionsUseCaseImpl = fetchAccountGroupPermissionsUseCase(fetchAccountGroupPermissionsRepositoryImpl)

const loginRepositoryImpl = loginRepostory(axosInstance)
const loginUseCaseImpl = loginUseCase(loginRepositoryImpl)

const getVisibleEquipmentsByAccountIDRepositoryImpl = getVisibleEquipmentsByAccountIDRepository(axosInstance)
const getVisibleEquipmentsByAccountIDUsecaseImpl = getVisibleEquipmentsByAccountIDUsecase(getVisibleEquipmentsByAccountIDRepositoryImpl)

const getVisibleVehiclesByAccountIDRepositoryImpl = getVisibleVehiclesByAccountIDRepository(axosInstance)
const getVisibleVehiclesByAccountIDUsecaseImpl = getVisibleVehiclesByAccountIDUsecase(getVisibleVehiclesByAccountIDRepositoryImpl)

const getVisibleEquipmentsByTruckDriverIDRepositoryImpl = getVisibleEquipmentsByTruckDriverIDRepository(axosInstance)
const getVisibleEquipmentsByTruckDriverIDUsecaseImpl = getVisibleEquipmentsByTruckDriverIDUsecase(getVisibleEquipmentsByTruckDriverIDRepositoryImpl)

const loginController = (context) => new LoginController(
  context,
  loginUseCaseImpl,
  changeAccountPasswordUseCaseImpl
)

const defaultController = (context) => new DefaultController(
  context,
  refreshUseCaseImpl
);

const homeController = (context) => new HomeController(
  context,
  fetchAccountGroupPermissionsUseCaseImpl
);

const dashboardController = (context) => new DashboardController(
  context
)

const dashboardServiceOrderPanelController = (context) => new DashboardServiceOrderControllerPanel(
  context
);

//Model
import fetchModelRepository from '@/module/model/data/repository/fetch_model_repository';
import fetchModelUseCase from '@/module/model/domain/usecase/fetch_model_usecase';
import createModelRepository from '@/module/model/data/repository/create_model_repository';
import createModelUseCase from '@/module/model/domain/usecase/create_model_usecase';
import changeModelRepository from '@/module/model/data/repository/change_model_repository';
import changeModelUseCase from '@/module/model/domain/usecase/change_model_usecase';
import deleteModelRepository from '@/module/model/data/repository/delete_model_repository';
import deleteModelUseCase from '@/module/model/domain/usecase/delete_model_usecase';

const fetchModelRepositoryImpl = fetchModelRepository(axosInstance)
const fetchModelUseCaseImpl = fetchModelUseCase(fetchModelRepositoryImpl)
const createModelRepositoryImpl = createModelRepository(axosInstance)
const createModelUseCaseImpl = createModelUseCase(createModelRepositoryImpl)
const changeModelRepositoryImpl = changeModelRepository(axosInstance)
const changeModelUseCaseImpl = changeModelUseCase(changeModelRepositoryImpl)
const deleteModelRepositoryImpl = deleteModelRepository(axosInstance)
const deleteModelUseCaseImpl = deleteModelUseCase(deleteModelRepositoryImpl)

const modelController = (context) => new ModelController(
  context,
  fetchModelUseCaseImpl,
  createModelUseCaseImpl,
  changeModelUseCaseImpl,
  deleteModelUseCaseImpl
)

//EquipmentHistory
import fetchEquipmentHistoryRepository from '@/module/equipmentHistory/data/repository/fetch_equipmentHistory_createdDate'
import fetchEquipmentHistoryUseCase from '@/module/equipmentHistory/domain/usecase/fetch_equipmentHistory_usecase'
import createEquipmentHistoryRepository from '@/module/equipmentHistory/data/repository/create_equipmentHistory_repository'
import createEquipmentHistoryUseCase from '@/module/equipmentHistory/domain/usecase/create_equipmentHistory_usecase'
import getEquipmentHistoryRepository from '@/module/equipmentHistory/data/repository/get_equipmentHistory_repository'
import getEquipmentHistoryUseCase from '@/module/equipmentHistory/domain/usecase/get_equipmentHistory_usecase'
import changeEquipmentHistoryRepository from '@/module/equipmentHistory/data/repository/change_equipmentHistory_repository';
import changeEquipmentHistoryUseCase from '@/module/equipmentHistory/domain/usecase/change_equipmentHistory_usecase';

const fetchEquipmentHistoryRepositoryImpl = fetchEquipmentHistoryRepository(axosInstance)
const fetchEquipmentHistoryUseCaseImpl = fetchEquipmentHistoryUseCase(fetchEquipmentHistoryRepositoryImpl)
const createEquipmentHistoryRepositoryImpl = createEquipmentHistoryRepository(axosInstance)
const createEquipmentHistoryUseCaseImpl = createEquipmentHistoryUseCase(createEquipmentHistoryRepositoryImpl)
const getEquipmentHistoryRepositoryImpl = getEquipmentHistoryRepository(axosInstance)
const getEquipmentHistoryUseCaseImpl = getEquipmentHistoryUseCase(getEquipmentHistoryRepositoryImpl)
const changeEquipmentHistoryRepositoryImpl = changeEquipmentHistoryRepository(axosInstance)
const changeEquipmentHistoryUseCaseImpl = changeEquipmentHistoryUseCase(changeEquipmentHistoryRepositoryImpl)

const equipmentHistoryController = (context) => new EquipmentHistoryController(
  context,
  fetchEquipmentHistoryUseCaseImpl,
  createEquipmentHistoryUseCaseImpl,
  changeEquipmentHistoryUseCaseImpl,
  getEquipmentHistoryUseCaseImpl
)


//Code
import fetchCodeRepository from '@/module/code/data/repository/fetch_code_repository';
import fetchCodeUseCase from '@/module/code/domain/usecase/fetch_code_usecase';
import createCodeRepository from '@/module/code/data/repository/create_code_repository';
import createCodeUseCase from '@/module/code/domain/usecase/create_code_usecase';
import changeCodeRepository from '@/module/code/data/repository/change_code_repository';
import changeCodeUseCase from '@/module/code/domain/usecase/change_code_usecase';
import deleteCodeRepository from '@/module/code/data/repository/delete_code_repository';
import deleteCodeUseCase from '@/module/code/domain/usecase/delete_code_usecase';

const fetchCodeRepositoryImpl = fetchCodeRepository(axosInstance)
const fetchCodeUseCaseImpl = fetchCodeUseCase(fetchCodeRepositoryImpl)
const createCodeRepositoryImpl = createCodeRepository(axosInstance)
const createCodeUseCaseImpl = createCodeUseCase(createCodeRepositoryImpl)
const changeCodeRepositoryImpl = changeCodeRepository(axosInstance)
const changeCodeUseCaseImpl = changeCodeUseCase(changeCodeRepositoryImpl)
const deleteCodeRepositoryImpl = deleteCodeRepository(axosInstance)
const deleteCodeUseCaseImpl = deleteCodeUseCase(deleteCodeRepositoryImpl)

const codeController = (context) => new CodeController(
  context,
  fetchCodeUseCaseImpl,
  createCodeUseCaseImpl,
  changeCodeUseCaseImpl,
  deleteCodeUseCaseImpl
)

//Account
import fetchAccountRepository from '@/module/account/data/repository/fetch_account_repository';
import fetchAccountUseCase from '@/module/account/domain/usecase/fetch_account_usecase';
import createAccountRepository from '@/module/account/data/repository/create_account_repository';
import createAccountUseCase from '@/module/account/domain/usecase/create_account_usecase';
import changeAccountRepository from '@/module/account/data/repository/change_account_repository';
import changeAccountUseCase from '@/module/account/domain/usecase/change_account_usecase';
import deleteAccountRepository from '@/module/account/data/repository/delete_account_repository';
import deleteAccountUseCase from '@/module/account/domain/usecase/delete_account_usecase';

const fetchAccountRepositoryImpl = fetchAccountRepository(axosInstance)
const fetchAccountUseCaseImpl = fetchAccountUseCase(fetchAccountRepositoryImpl)
const createAccountRepositoryImpl = createAccountRepository(axosInstance)
const createAccountUseCaseImpl = createAccountUseCase(createAccountRepositoryImpl)
const changeAccountRepositoryImpl = changeAccountRepository(axosInstance)
const changeAccountUseCaseImpl = changeAccountUseCase(changeAccountRepositoryImpl)
const changeAccountPasswordRepositoryImpl = changeAccountPasswordRepository(axosInstance)
const changeAccountPasswordUseCaseImpl = changeAccountPasswordUseCase(changeAccountPasswordRepositoryImpl)
const deleteAccountRepositoryImpl = deleteAccountRepository(axosInstance)
const deleteAccountUseCaseImpl = deleteAccountUseCase(deleteAccountRepositoryImpl)


const accountController = (context) => new AccountController(
  context,
  fetchAccountUseCaseImpl,
  createAccountUseCaseImpl,
  changeAccountUseCaseImpl,
  deleteAccountUseCaseImpl,
  fetchClientUseCaseImpl,
  fetchVehicleUseCaseImpl,
  fetchEquipmentUseCaseImpl,
  fetchTechnicianUsecaseImpl,
  refreshUseCaseImpl,
  getVisibleEquipmentsByAccountIDUsecaseImpl,
  getVisibleVehiclesByAccountIDUsecaseImpl
)


//Client
import fetchClientRepository from '@/module/client/data/repository/fetch_client_repository';
import fetchClientUseCase from '@/module/client/domain/usecase/fetch_client_usecase';
import createClientRepository from '@/module/client/data/repository/create_client_repository';
import createClientUseCase from '@/module/client/domain/usecase/create_client_usecase';
import changeClientRepository from '@/module/client/data/repository/change_client_repository';
import changeClientUseCase from '@/module/client/domain/usecase/change_client_usecase';
import deleteClientRepository from '@/module/client/data/repository/delete_client_repository';
import deleteClientUseCase from '@/module/client/domain/usecase/delete_client_usecase';
import fetchCityRepository from '@/module/client/data/repository/fetch_city_repository';
import fetchCityUseCase from '@/module/client/domain/usecase/fetch_city_usecase';

const fetchClientRepositoryImpl = fetchClientRepository(axosInstance)
const fetchClientUseCaseImpl = fetchClientUseCase(fetchClientRepositoryImpl)
const createClientRepositoryImpl = createClientRepository(axosInstance)
const createClientUseCaseImpl = createClientUseCase(createClientRepositoryImpl)
const changeClientRepositoryImpl = changeClientRepository(axosInstance)
const changeClientUseCaseImpl = changeClientUseCase(changeClientRepositoryImpl)
const deleteClientRepositoryImpl = deleteClientRepository(axosInstance)
const deleteClientUseCaseImpl = deleteClientUseCase(deleteClientRepositoryImpl)
const fetchCityRepositoryImpl = fetchCityRepository(axosInstance)
const fetchCityUseCaseImpl = fetchCityUseCase(fetchCityRepositoryImpl)


const clientController = (context) => new ClientController(
  context,
  fetchClientUseCaseImpl,
  createClientUseCaseImpl,
  changeClientUseCaseImpl,
  deleteClientUseCaseImpl,
  fetchCityUseCaseImpl
)

//Vehicle
import fetchVehicleRepository from '@/module/vehicle/data/repository/fetch_vehicle_repository';
import fetchVehicleUseCase from '@/module/vehicle/domain/usecase/fetch_vehicle_usecase';
import createVehicleRepository from '@/module/vehicle/data/repository/create_vehicle_repository';
import createVehicleUseCase from '@/module/vehicle/domain/usecase/create_vehicle_usecase';
import changeVehicleRepository from '@/module/vehicle/data/repository/change_vehicle_repository';
import changeVehicleUseCase from '@/module/vehicle/domain/usecase/change_vehicle_usecase';
import deleteVehicleRepository from '@/module/vehicle/data/repository/delete_vehicle_repository';
import deleteVehicleUseCase from '@/module/vehicle/domain/usecase/delete_vehicle_usecase';

const fetchVehicleRepositoryImpl = fetchVehicleRepository(axosInstance)
const fetchVehicleUseCaseImpl = fetchVehicleUseCase(fetchVehicleRepositoryImpl)
const createVehicleRepositoryImpl = createVehicleRepository(axosInstance)
const createVehicleUseCaseImpl = createVehicleUseCase(createVehicleRepositoryImpl)
const changeVehicleRepositoryImpl = changeVehicleRepository(axosInstance)
const changeVehicleUseCaseImpl = changeVehicleUseCase(changeVehicleRepositoryImpl)
const deleteVehicleRepositoryImpl = deleteVehicleRepository(axosInstance)
const deleteVehicleUseCaseImpl = deleteVehicleUseCase(deleteVehicleRepositoryImpl)

const vehicleController = (context) => new VehicleController(
  context,
  fetchVehicleUseCaseImpl,
  createVehicleUseCaseImpl,
  changeVehicleUseCaseImpl,
  deleteVehicleUseCaseImpl,
  fetchClientUseCaseImpl,
  fetchEquipmentUseCaseImpl,
  refreshUseCaseImpl,
  createReleaseUseCaseImpl,
  createVehicleMaintenanceUseCaseImpl
)

//Equipment
import fetchEquipmentRepository from '@/module/equipment/data/repository/fetch_equipment_repository';
import fetchEquipmentUseCase from '@/module/equipment/domain/usecase/fetch_equipment_usecase';
import createEquipmentRepository from '@/module/equipment/data/repository/create_equipment_repository';
import createEquipmentUseCase from '@/module/equipment/domain/usecase/create_equipment_usecase';
import changeEquipmentRepository from '@/module/equipment/data/repository/change_equipment_repository';
import changeEquipmentUseCase from '@/module/equipment/domain/usecase/change_equipment_usecase';
import deleteEquipmentRepository from '@/module/equipment/data/repository/delete_equipment_repository';
import deleteEquipmentUseCase from '@/module/equipment/domain/usecase/delete_equipment_usecase';
import fetchEquipmentTypeRepository from '@/module/equipment/data/repository/fetch_equipment_type_repository';
import fetchEquipmentTypeUseCase from '@/module/equipment/domain/usecase/fetch_equipment_type_usecase';
import countEquipmentPlateRepository from '@/module/equipment/data/repository/count_equipment_plate_repository';
import countEquipmentPlateUseCase from '@/module/equipment/domain/usecase/count_equipment_plate_usecase';
import createReleaseRepository from '@/module/equipment/data/repository/create_release_repository';
import createReleaseUseCase from '@/module/equipment/domain/usecase/create_release_usecase';

const fetchEquipmentRepositoryImpl = fetchEquipmentRepository(axosInstance)
const fetchEquipmentUseCaseImpl = fetchEquipmentUseCase(fetchEquipmentRepositoryImpl)
const createEquipmentRepositoryImpl = createEquipmentRepository(axosInstance)
const createEquipmentUseCaseImpl = createEquipmentUseCase(createEquipmentRepositoryImpl)
const changeEquipmentRepositoryImpl = changeEquipmentRepository(axosInstance)
const changeEquipmentUseCaseImpl = changeEquipmentUseCase(changeEquipmentRepositoryImpl)
const deleteEquipmentRepositoryImpl = deleteEquipmentRepository(axosInstance)
const deleteEquipmentUseCaseImpl = deleteEquipmentUseCase(deleteEquipmentRepositoryImpl)
const fetchEquipmentTypeRepositoryImpl = fetchEquipmentTypeRepository(axosInstance)
const fetchEquipmentTypeUseCaseImpl = fetchEquipmentTypeUseCase(fetchEquipmentTypeRepositoryImpl)
const countEquipmentPlateRepositoryImpl = countEquipmentPlateRepository(axosInstance)
const countEquipmentPlateUseCaseImpl = countEquipmentPlateUseCase(countEquipmentPlateRepositoryImpl)
const createReleaseRepositoryImpl = createReleaseRepository(axosInstance)
const createReleaseUseCaseImpl = createReleaseUseCase(createReleaseRepositoryImpl)


const equipmentController = (context) => new EquipmentController(
  context,
  fetchEquipmentUseCaseImpl,
  createEquipmentUseCaseImpl,
  changeEquipmentUseCaseImpl,
  deleteEquipmentUseCaseImpl,
  fetchModelUseCaseImpl,
  fetchVehicleUseCaseImpl,
  fetchEquipmentTypeUseCaseImpl,
  countEquipmentPlateUseCaseImpl,
  fetchClientUseCaseImpl,
  createReleaseUseCaseImpl,
  refreshUseCaseImpl
)

//TruckDriver
import fetchTruckDriverRepository from '@/module/truckDriver/data/repository/fetch_truckDriver_repository';
import fetchTruckDriverUseCase from '@/module/truckDriver/domain/usecase/fetch_truckDriver_usecase';
import createTruckDriverRepository from '@/module/truckDriver/data/repository/create_truckDriver_repository';
import createTruckDriverUseCase from '@/module/truckDriver/domain/usecase/create_truckDriver_usecase';
import changeTruckDriverRepository from '@/module/truckDriver/data/repository/change_truckDriver_repository';
import changeTruckDriverUseCase from '@/module/truckDriver/domain/usecase/change_truckDriver_usecase';
import deleteTruckDriverRepository from '@/module/truckDriver/data/repository/delete_truckDriver_repository';
import deleteTruckDriverUseCase from '@/module/truckDriver/domain/usecase/delete_truckDriver_usecase';

const fetchTruckDriverRepositoryImpl = fetchTruckDriverRepository(axosInstance)
const fetchTruckDriverUseCaseImpl = fetchTruckDriverUseCase(fetchTruckDriverRepositoryImpl)
const createTruckDriverRepositoryImpl = createTruckDriverRepository(axosInstance)
const createTruckDriverUseCaseImpl = createTruckDriverUseCase(createTruckDriverRepositoryImpl)
const changeTruckDriverRepositoryImpl = changeTruckDriverRepository(axosInstance)
const changeTruckDriverUseCaseImpl = changeTruckDriverUseCase(changeTruckDriverRepositoryImpl)
const deleteTruckDriverRepositoryImpl = deleteTruckDriverRepository(axosInstance)
const deleteTruckDriverUseCaseImpl = deleteTruckDriverUseCase(deleteTruckDriverRepositoryImpl)


const truckDriverController = (context) => new TruckDriverController(
  context,
  fetchTruckDriverUseCaseImpl,
  createTruckDriverUseCaseImpl,
  changeTruckDriverUseCaseImpl,
  deleteTruckDriverUseCaseImpl,
  fetchEquipmentUseCaseImpl,
  getVisibleEquipmentsByTruckDriverIDUsecaseImpl,
)

//ServiceOrder
import fetchServiceOrderRepository from '@/module/serviceOrder/data/repository/fetch_service_order_repository';
import fetchServiceOrderUseCase from '@/module/serviceOrder/domain/usecase/fetch_service_order_usecase';
import createServiceOrderRepository from '@/module/serviceOrder/data/repository/create_service_order_repository';
import createServiceOrderUsecase from '@/module/serviceOrder/domain/usecase/create_service_order_usecase';
import changeServiceOrderRepository from '@/module/serviceOrder/data/repository/change_service_order_repository';
import changeServiceOrderUsecase from '@/module/serviceOrder/domain/usecase/change_service_order_usecase';
import deleteServiceOrderRepository from '@/module/serviceOrder/data/repository/delete_service_order_repository';
import deleteServiceOrderUsecase from '@/module/serviceOrder/domain/usecase/delete_service_order_usecase';
import fetchTaskTypeRepository from '@/module/serviceOrder/data/repository/fetch_task_type_repository';
import fetchTaskTypeUseCase from '@/module/serviceOrder/domain/usecase/fetch_task_type_usecase';
import fetchStatusRepository from '@/module/serviceOrder/data/repository/fetch_status_repository';
import fetchStatusUseCase from '@/module/serviceOrder/domain/usecase/fetch_status_usecase';

//VisitServiceOrder
import getServiceOrderByIdReportRepository from '@/module/visitServiceOrder/data/repository/get_service_order_report_id';
import getServiceOrderByIDReportUseCase from '@/module/visitServiceOrder/domain/usecase/get_service_order_by_id_report_usecase'
import patchServiceOrderReportIdReportDataRepository from '@/module/visitServiceOrder/data/repository/patch_service_order_report_id_report_data';
import patchServiceOrderReportIdReportDataUseCase from '@/module/visitServiceOrder/domain/usecase/patch_service_order_report_id_report_data_usecase';
import createServiceOrderReportImageRepository from '@/module/visitServiceOrder/data/repository/create_service_order_report_image_repository';
import createServiceOrderReportImageUseCase from '@/module/visitServiceOrder/domain/usecase/create_service_order_report_image_usecase';
import changeServiceOrderReportImageRepository from '@/module/visitServiceOrder/data/repository/change_service_order_report_image_repository';
import changeServiceOrderReportImageUseCase from '@/module/visitServiceOrder/domain/usecase/change_service_order_report_image_usecase';
import createConfirmImageUploadRepository from '@/module/visitServiceOrder/data/repository/create_confirm_image_upload_repository';
import createConfirmImageUploadUseCase from '@/module/visitServiceOrder/domain/usecase/create_confirm_image_upload_usecase';

const fetchServiceOrderRepositoryImpl = fetchServiceOrderRepository(axosInstance)
const fetchServiceOrderUseCaseImpl = fetchServiceOrderUseCase(fetchServiceOrderRepositoryImpl)
const createServiceOrderRepositoryImpl = createServiceOrderRepository(axosInstance)
const createServiceOrderUsecaseImpl = createServiceOrderUsecase(createServiceOrderRepositoryImpl)
const changeServiceOrderRepositoryImpl = changeServiceOrderRepository(axosInstance)
const changeServiceOrderUsecaseImpl = changeServiceOrderUsecase(changeServiceOrderRepositoryImpl)
const deleteServiceOrderRepositoryImpl = deleteServiceOrderRepository(axosInstance)
const deleteServiceOrderUsecaseImpl = deleteServiceOrderUsecase(deleteServiceOrderRepositoryImpl)
const fetchTaskTypeRepositoryImpl = fetchTaskTypeRepository(axosInstance)
const fetchTaskTypeUseCaseImpl = fetchTaskTypeUseCase(fetchTaskTypeRepositoryImpl)
const fetchStatusRepositoryImpl = fetchStatusRepository(axosInstance)
const fetchStatusUseCaseImpl = fetchStatusUseCase(fetchStatusRepositoryImpl)
const getServiceOrderByIdReportRepositoryImpl = getServiceOrderByIdReportRepository(axosInstance)
const getServiceOrderByIDReportUseCaseImpl = getServiceOrderByIDReportUseCase(getServiceOrderByIdReportRepositoryImpl)
const patchServiceOrderReportIdReportDataRepositoryImpl = patchServiceOrderReportIdReportDataRepository(axosInstance)
const patchServiceOrderReportIdReportDataUseCaseImpl = patchServiceOrderReportIdReportDataUseCase(patchServiceOrderReportIdReportDataRepositoryImpl)
const createServiceOrderReportImageRepositoryImpl = createServiceOrderReportImageRepository(axosInstance)
const createServiceOrderReportImageUseCaseImpl = createServiceOrderReportImageUseCase(createServiceOrderReportImageRepositoryImpl)
const changeServiceOrderReportImageRepositoryImpl = changeServiceOrderReportImageRepository(axosInstance)
const changeServiceOrderReportImageUseCaseImpl = changeServiceOrderReportImageUseCase(changeServiceOrderReportImageRepositoryImpl)
const createConfirmImageUploadRepositoryImpl = createConfirmImageUploadRepository(axosInstance)
const createConfirmImageUploadUseCaseImpl = createConfirmImageUploadUseCase(createConfirmImageUploadRepositoryImpl)

const serviceOrderController = (context) => new ServiceOrderController(
  context,
  fetchClientUseCaseImpl,
  fetchVehicleUseCaseImpl,
  fetchServiceOrderUseCaseImpl,
  fetchTechnicianUsecaseImpl,
  createServiceOrderUsecaseImpl,
  changeServiceOrderUsecaseImpl,
  deleteServiceOrderUsecaseImpl,
  fetchTaskTypeUseCaseImpl,
  fetchStatusUseCaseImpl
)

// visitServiceOrder
const visitServiceOrderController = (context) => new VisitServiceOrderController(
  context,
  fetchClientUseCaseImpl,
  fetchVehicleUseCaseImpl,
  fetchServiceOrderUseCaseImpl,
  fetchTechnicianUsecaseImpl,
  fetchTaskTypeUseCaseImpl,
  fetchStatusUseCaseImpl,
  changeServiceOrderUsecaseImpl,
  getServiceOrderByIDReportUseCaseImpl,
  patchServiceOrderReportIdReportDataUseCaseImpl,
  createServiceOrderReportImageUseCaseImpl,
  changeServiceOrderReportImageUseCaseImpl,
  createConfirmImageUploadUseCaseImpl
)

//Technician
import fetchTechnicianRepository from '@/module/technician/data/repository/fetch_technician_repository';
import fetchTechnicianUsecase from '@/module/technician/domain/usecase/fetch_technician_usecase';
import createTechnicianRepository from '@/module/technician/data/repository/create_technician_repository';
import createTechnicianUsecase from '@/module/technician/domain/usecase/create_technician_usecase';
import changeTechnicianRepository from '@/module/technician/data/repository/change_technician_repository';
import changeTechnicianUsecase from '@/module/technician/domain/usecase/change_technician_usecase';
import deleteTechnicianRepository from '@/module/technician/data/repository/delete_technician_repository';
import deleteTechnicianUsecase from '@/module/technician/domain/usecase/delete_technician_usecase';

const fetchTechnicianRepositoryImpl = fetchTechnicianRepository(axosInstance)
const fetchTechnicianUsecaseImpl = fetchTechnicianUsecase(fetchTechnicianRepositoryImpl)
const createTechnicianRepositoryImpl = createTechnicianRepository(axosInstance)
const createTechnicianUsecaseImpl = createTechnicianUsecase(createTechnicianRepositoryImpl)
const changeTechnicianRepositoryImpl = changeTechnicianRepository(axosInstance)
const changeTechnicianUsecaseImpl = changeTechnicianUsecase(changeTechnicianRepositoryImpl)
const deleteTechnicianRepositoryImpl = deleteTechnicianRepository(axosInstance)
const deleteTechnicianUsecaseImpl = deleteTechnicianUsecase(deleteTechnicianRepositoryImpl)

const technicianController = (context) => new TechnicianController(
  context,
  fetchTechnicianUsecaseImpl,
  fetchCityUseCaseImpl,
  createTechnicianUsecaseImpl,
  changeTechnicianUsecaseImpl,
  deleteTechnicianUsecaseImpl
)

//Release
import fetchReleaseRepository from '@/module/release/data/repository/fetch_release_repository';
import fetchReleaseUseCase from '@/module/release/domain/usecase/fetch_release_usecase';
import fetchAccountGroupPermissionsUseCase from '@/core/domain/usecase/fetch_account_group_permissions_usecase';
import fetchAccountGroupPermissionsRepository from '@/core/data/repository/fetch_account_group_permissions_repository';
import getVisibleEquipmentsByAccountIDRepository from '@/module/equipment/data/repository/get_visible_equipments_by_account_id_repository';
import getVisibleEquipmentsByAccountIDUsecase from '@/module/equipment/domain/usecase/get_visible_equipments_by_account_id_usecase';
import getVisibleVehiclesByAccountIDRepository from '@/module/vehicle/data/repository/get_visible_vehicles_by_account_id_repository';
import getVisibleVehiclesByAccountIDUsecase from '@/module/vehicle/domain/usecase/get_visible_vehicles_by_account_id_usecase';
import changeAccountPasswordRepository from '@/module/account/data/repository/change_account_password_repository';
import changeAccountPasswordUseCase from '@/module/account/domain/usecase/change_account_password_usecase';

const fetchReleaseRepositoryImpl = fetchReleaseRepository(axosInstance)
const fetchReleaseUseCaseImpl = fetchReleaseUseCase(fetchReleaseRepositoryImpl)

const releaseController = (context) => new ReleaseController(
  context,
  fetchReleaseUseCaseImpl,
  fetchAccountUseCaseImpl,
  fetchTruckDriverUseCaseImpl,
  fetchClientUseCaseImpl,
  fetchCodeUseCaseImpl,
  fetchModelUseCaseImpl,
  fetchVehicleUseCaseImpl,
  fetchEquipmentUseCaseImpl,
)

//ReleaseConfirmation
import fetchReleaseConfirmationRepository from '@/module/releaseConfirmation/data/fetch_releaseConfirmation_repository'; 
import fetchReleaseConfirmationUseCase from '@/module/releaseConfirmation/domain/usecase/fetch_releaseConfirmation_usecase'; 

import changeReleaseConfirmationRepository from '@/module/releaseConfirmation/data/change_releaseConfirmation_repository'; 
import changeReleaseConfirmationUseCase from '@/module/releaseConfirmation/domain/usecase/change_releaseConfirmation_usecase'; 

const fetchReleaseConfirmationRepositoryImpl = fetchReleaseConfirmationRepository(axosInstance)
const fetchReleaseConfirmationUseCaseImpl = fetchReleaseConfirmationUseCase(fetchReleaseConfirmationRepositoryImpl)
const changeReleaseConfirmationRepositoryImpl = changeReleaseConfirmationRepository(axosInstance)
const changeReleaseConfirmationUseCaseImpl = changeReleaseConfirmationUseCase(changeReleaseConfirmationRepositoryImpl)

const releaseConfirmationController = (context) => new ReleaseConfirmationController(
  context,
  fetchReleaseConfirmationUseCaseImpl,
  changeReleaseConfirmationUseCaseImpl
)

//VehicleMaintenance
import fetchVechicleMaintenanceRepository from '@/module/vehicleMaintenance/data/repository/fetch_vehicleMaintenance_repository';
import fetchVehicleMaintenanceUseCase from '@/module/vehicleMaintenance/domain/usecase/fetch_vehicleMaintenance_usecase';
import createVehicleMaintenanceRepository from '@/module/vehicleMaintenance/data/repository/create_vehicleMaintenance_repository';
import createVehicleMaintenanceUseCase from '@/module/vehicleMaintenance/domain/usecase/create_vehicleMaintenance_usecase';
import deleteVehicleMaintenanceRepository from '@/module/vehicleMaintenance/data/repository/delete_vehicleMaintenance_repository';
import deleteVehicleMaintenanceUseCase from '@/module/vehicleMaintenance/domain/usecase/delete_vehicleMaintenance_usecase';
import getVisibleEquipmentsByTruckDriverIDRepository from '@/module/equipment/data/repository/get_visible_equipaments_by_truck_driver_id_repository';
import getVisibleEquipmentsByTruckDriverIDUsecase from '@/module/equipment/domain/usecase/get_visible_equipments_by_truck_driver_id_usecase';

const fetchVechicleMaintenanceRepositoryImpl = fetchVechicleMaintenanceRepository(axosInstance)
const fetchVehicleMaintenanceUseCaseImpl = fetchVehicleMaintenanceUseCase(fetchVechicleMaintenanceRepositoryImpl)
const createVehicleMaintenanceRepositoryImpl = createVehicleMaintenanceRepository(axosInstance)
const createVehicleMaintenanceUseCaseImpl = createVehicleMaintenanceUseCase(createVehicleMaintenanceRepositoryImpl)
const deleteVehicleMaintenanceRepositoryImpl = deleteVehicleMaintenanceRepository(axosInstance)
const deleteVehicleMaintenanceUseCaseImpl = deleteVehicleMaintenanceUseCase(deleteVehicleMaintenanceRepositoryImpl)

const vehicleMaintenanceController = (context) => new VehicleMaintenanceController(
  context,
  fetchVehicleMaintenanceUseCaseImpl,
  createVehicleMaintenanceUseCaseImpl,
  deleteVehicleMaintenanceUseCaseImpl,
)

//EquipmentStatus
import fetchEquipmentStatusRepository from '@/module/equipmentStatus/data/repository/fetch_equipmentStatus_repository';
import fetchEquipmentStatusUseCase from '@/module/equipmentStatus/domain/usecase/fetch_equipmentStatus_usecase';
import fetchEquipmentStatusLogRepository from '@/module/equipmentStatus/data/repository/fetch_equipmentStatusLog_repository';
import fetchEquipmentStatusLogUseCase from '@/module/equipmentStatus/domain/usecase/fetch_equipmentStatusLog_usecase';

const fetchEquipmentStatusRepositoryImpl = fetchEquipmentStatusRepository(axosInstance)
const fetchEquipmentStatusUseCaseImpl = fetchEquipmentStatusUseCase(fetchEquipmentStatusRepositoryImpl)
const fetchEquipmentStatusLogRepositoryImpl = fetchEquipmentStatusLogRepository(axosInstance)
const fetchEquipmentStatusLogUseCaseImpl = fetchEquipmentStatusLogUseCase(fetchEquipmentStatusLogRepositoryImpl)

const equipmentStatusController = (context) => new EquipmentStatusController(
  context,
  fetchEquipmentStatusUseCaseImpl,
  fetchEquipmentStatusLogUseCaseImpl
)

export {
  defaultController,
  loginController,
  homeController,
  dashboardController,
  modelController,
  codeController,
  clientController,
  vehicleController,
  equipmentController,
  accountController,
  truckDriverController,
  releaseController,
  dashboardServiceOrderPanelController,
  serviceOrderController,
  visitServiceOrderController,
  technicianController,
  releaseConfirmationController,
  equipmentHistoryController,
  vehicleMaintenanceController,
  equipmentStatusController
}
